<h3 class="title configurator-title">{{ 'carpentry.accessories.title' | translate }}</h3>

<div class="config-container shadow">
  <h4
    class="title configurator-subtitle collapse-button"
    [ngClass]="{ active: subStep === 1 }"
    (click)="toggleCollapse(1)">
    <span>{{ 'carpentry.accessories.available-accessories' | translate }}</span>
  </h4>

  <ng-casto-loader *ngIf="!accessories"></ng-casto-loader>

  <div class="collapse-block" *ngIf="subStep === 1 && accessories">
    <div class="accessory-container">
      <div
        class="accessory-card shadow"
        *ngFor="let accessory of accessories"
        [ngClass]="{ active: isAccessorySelected(accessory.id) }"
        (click)="selectAccessory(accessory)"
        (mouseenter)="checkAccessory(accessory.id)"
        (mouseleave)="uncheckAccessory(accessory.id)">
        <ng-casto-img-loader
          [imgSrc]="baseImgUrl + accessory.thumbnail"
          [imgClass]="'accessory-img'"></ng-casto-img-loader>

        <p class="accessory-title form-check form-check-inline">
          <input
            class="form-check-input"
            type="checkbox"
            id="title-{{ accessory.id }}"
            [checked]="isAccessorySelected(accessory.id)" />
          <label class="form-check-label">
            {{ accessory.label }}
          </label>
          <a *ngIf="accessory.description" class="casto-tooltip" [tooltip]="accessory.description">?</a>
        </p>

        <p class="mt-2">
          <span>
            {{ 'carpentry.accessories.priceTTC' | translate }} : {{ getPriceTtc(accessory) | number: '1.2-2' : 'fr' }}€
            <small>({{ getPriceHt(accessory) | number: '1.2-2' : 'fr' }}€ HT)</small>
          </span>
        </p>

        <div class="form-group accessory-quantity">
          <label for="quantity-{{ accessory.id }}">{{ 'carpentry.accessories.quantity' | translate }}</label>
          <input
            type="number"
            [min]="1"
            class="form-control form-control-sm"
            id="quantity-{{ accessory.id }}"
            [value]="getAccessoryQuantity(accessory.id)"
            (click)="$event.stopPropagation()"
            (change)="updateQuantity($event, accessory.id)"
            [disabled]="!isAccessorySelected(accessory.id)" />
        </div>
      </div>
    </div>

    <div *ngIf="accessories.length === 0">
      <p class="text-muted">Aucun accessoire n'est disponible.</p>
    </div>
  </div>
</div>
